import { AppToastConfig, toast } from 'ui-kit';
import { getTranslate } from '@/i18n/getTranslate.ts';

type ToastProps = Omit<AppToastConfig, 'title'> & { title?: string };

export const errorToast = async ({
  title,
  description,
  ...options
}: ToastProps) => {
  const t = await getTranslate('common');
  toast.error({
    description,
    title: title ?? t('TOAST_ERROR_HEADER'),
    ...options,
  });
};

export const successToast = async ({
  title,
  description,
  ...options
}: ToastProps) => {
  const t = await getTranslate('common');
  toast.success({
    description,
    title: title ?? t('SUCCESS_TOAST_HEADER'),
    ...options,
  });
};
